<template>
  <TsSection>
    <TsLoadingCircularSpinner />
    <TsTypography append-class="text-base text-4xl text-center text-primary font-bold">Your Procard Application is in Progress....</TsTypography>
  </TsSection>
</template>

<script setup lang="ts">
import { PROCARD_STATUS_LIST, type ProCardPostApplyStatus } from '~/types/ecom/procard.type';

const route = useRoute('pro-card-application-process___nl-NL___default');
const procardStore = useProCardStoreV2();

const TsLoadingCircularSpinner = defineAsyncComponent(() => import('~/components/organisms/TsLoadingCircularSpinner.vue'));

definePageMeta({
  middleware: ["is-logged-in"]
});

function handleExternalProcessStatus(status: ProCardPostApplyStatus) {
  switch (status) {
    case 'ok':
    case 'pending': 
    case 'print': 
      procardStore.getDraftData();
      procardStore.redirectToThankyou('PROCARD');
      break;
    case 'failed':
    case 'cancel':
    return navigateTo("/account/home");
  }
}

onMounted(() => {
  const processStatus = route.query.status as ProCardPostApplyStatus;
  if(!processStatus) return;
  PROCARD_STATUS_LIST.includes(processStatus) && handleExternalProcessStatus(processStatus);
})
</script>